import styled from 'styled-components';
import { SuccessButton as RawSuccess } from 'liber-components';

export const SuccessButton = styled(RawSuccess).attrs(() => ({ version: 2, size: 'large' }))`
  width: 256px;
  margin-top: 40px;
`;
